import { render, staticRenderFns } from "./zhaogong.vue?vue&type=template&id=50c082d3&scoped=true&"
import script from "./zhaogong.vue?vue&type=script&lang=js&"
export * from "./zhaogong.vue?vue&type=script&lang=js&"
import style0 from "./zhaogong.vue?vue&type=style&index=0&id=50c082d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c082d3",
  null
  
)

export default component.exports